import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TableSkeleton: React.FC = () => {
  const rowCount = 10;

  // Column width classes based on your actual table
  const columnWidths = [
    'min-w-[120px]', // Name
    'min-w-[90px] hide-vs',  // Category
    'min-w-[58px] hide-sm',  // Size
    'min-w-[80px]',  // Actions
  ];

  return (
    <div className="max-w-6xl mx-auto">
      <div className="border rounded-md bg-white shadow-md overflow-x-auto">
        <table className="w-full table-auto text-sm">
          <thead className="bg-gray-100">
            <tr>
              {columnWidths.map((colClass, idx) => (
                <th key={idx} className={`px-2 py-2 ${colClass}`}>
                  <Skeleton height={20} />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rowCount }).map((_, rowIdx) => (
              <tr key={rowIdx} className="border-t">
                {columnWidths.map((colClass, colIdx) => (
                  <td key={colIdx} className={`px-2 py-3 ${colClass}`}>
                    <Skeleton height={16} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableSkeleton;
